import {Component, Inject, OnInit} from "@angular/core";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'ral-open',
  templateUrl: 'open.component.html'
})
export class OpenComponent  implements OnInit
{
  ngOnInit(): void {
    window.open(environment.hubCallcenter);
  }

}

